/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { MenuList, styled } from '@mui/material';

export const NavigationStyledMenuList = styled(MenuList)(({ theme }) => {
  const divider = `1px solid ${theme.colors.grey400}`;

  return {
    gap: '16px',
    padding: '8px 0',
    borderTop: divider,
    borderBottom: divider,
  };
});
